import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Modal from '@bd/bdui-modal';
import { css } from '@bd/bdui-styles/emotion';
import tc from 'tinycolor2';
import { colors } from '../styles';
// import withData from '@bd/bdcore-data';
// import ContactFormModal from '../pages/ContactUs/ContactFormModal';
// import Form from './Forms/Form';

const styles = css`
  .ContactButton:focus {
    outline: 0;
  }
`;

const modalStyles = css`
  iframe {
    width: 100vw;
    height: 100vh;
    position: relative;
    z-index: 1;
    border: 0;
  }
`;

const modalOverlayStyles = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  background-color: ${tc(colors.brand4Darkest).setAlpha(0.9).toRgbString()};
  overflow-y: auto;
`;

class ScheduleModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    window.addEventListener('message', event => {
      if (typeof event.data === 'string' && event.data.match(/scheduler:close/)) {
        this.closeModal();
      }
    });
  }

  openModal(e) {
    let currentElem = e.target;

    while (currentElem.tagName !== 'A' && currentElem.parentNode !== document) {
      currentElem = currentElem.parentNode;
    }

    if (currentElem.nodeName !== 'A') {
      e.preventDefault();
      this.setState({
        modalIsOpen: true,
      });
    }
  }

  closeModal(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({ modalIsOpen: false });
  }
  render() {
    const { children, community } = this.props;
    return (
      <div className={styles}>
        <span className="ContactButton" role="button" tabIndex={0} onClick={this.openModal}>
          {children}
        </span>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel="Contact Modal"
          className={modalStyles}
          overlayClassName={modalOverlayStyles}
        >
          <iframe src={get(community, 'schedule_appointment_link')} title={`Schedule Appointment for ${community.name}`} />
        </Modal>
      </div>
    );
  }
}

ScheduleModal.propTypes = {
  community: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

export default ScheduleModal;



// WEBPACK FOOTER //
// ./src/components/ScheduleModal.js